export enum DownloadFileBaseUrl {
  BASE_URL = 'https://smartharvest-data-manager.azurewebsites.net'
}
